import './Loader.scss';

const Loader = ({ centered }) => {
	const wrapperClass = `loader-wrapper ${centered ? 'centered' : ''}`;
	return (
		<div className={wrapperClass}>
			<div className='loader-content'>
				<div></div>
				<div></div>
			</div>
		</div>
	);
};

export default Loader;